import { useTranslation } from 'react-i18next';
import DeviceSelect from './DeviceSelect';

const DeviceForm = ({ botId, disabled, deviceId, show, required }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  const label = t('devices.form.title.label');
  return (
    <>
      <hr />

      <div className="row mb-4 col-8">
        <div className="col-8 form-group mb-3">
          <label htmlFor="titleInput">{label}:</label>
          <DeviceSelect required={required} defaultValue={deviceId} disabled={disabled} botId={botId} placeholder={label} />
        </div>
      </div>
    </>
  );
};

export default DeviceForm;
